"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderUnitBuilderFactory = void 0;
const trade_1 = require("@tencent/tccp-frontend-contract/trade");
const ProductTypeText_1 = require("../constant/ProductTypeText");
const list_1 = require("../utils/list");
const SUPPORTED_SPU_META_KEY = ['ProductType'];
const renderUnitBuilderFactory = (spuMeta) => (paramKeyList, buyDescription) => {
    const { EchoParamList: echoParamList = [], CustomGroupList: customGroupList = [], RefinedOrder: refineOrder = [], ExtraInfoList: extraInfoList = [], InputTypeList: inputTypeList = [], } = buyDescription !== null && buyDescription !== void 0 ? buyDescription : {};
    const echoParams = (0, list_1.listToRecord)(echoParamList, x => [x.UnitKey, x.Echo]);
    const customGroups = (0, list_1.listToRecord)(customGroupList, x => [x.GroupKey, x.GroupName]);
    const extraInfo = (0, list_1.listToRecord)(extraInfoList, x => [x.UnitKey, x.Text]);
    const inputTypeConfig = (0, list_1.listToRecord)(inputTypeList, x => [x.UnitKey, x.InputType]);
    // spu-meta在前，paramList在后
    const spuMetaKeyList = SUPPORTED_SPU_META_KEY.map(key => `${trade_1.BuyUITypeEnum.SpuMeta}://${spuMeta.SpuCode}.${key}`);
    const renderUnitKeyList = [...spuMetaKeyList, ...paramKeyList];
    const sortedParamKeyList = (0, trade_1.reflowRenderUnitKey)(renderUnitKeyList, refineOrder);
    const renderUnitList = [];
    // 根据key生成组件基本信息
    for (const renderUnitKey of sortedParamKeyList) {
        const renderUnit = renderUnitBuilder(renderUnitKey, {
            customGroups,
            echoParams,
            spuMeta,
            extraInfo,
            inputTypeConfig,
        });
        if (renderUnit) {
            renderUnitList.push(renderUnit);
        }
    }
    return renderUnitList;
};
exports.renderUnitBuilderFactory = renderUnitBuilderFactory;
function renderUnitBuilder(key, { customGroups, echoParams, spuMeta, extraInfo, inputTypeConfig, }) {
    var _a, _b, _c;
    if ((0, trade_1.isGroupKey)(key)) {
        return {
            key,
            type: trade_1.BuyUITypeEnum.Group,
            description: extraInfo[key],
            echo: (_a = echoParams[key]) !== null && _a !== void 0 ? _a : true,
            extra: {
                groupName: (_b = customGroups[key]) !== null && _b !== void 0 ? _b : key,
            },
        };
    }
    if ((0, trade_1.isSpuMetaKey)(key)) {
        return {
            key,
            type: trade_1.BuyUITypeEnum.SpuMeta,
            description: extraInfo[key],
            echo: (_c = echoParams[key]) !== null && _c !== void 0 ? _c : false,
            extra: {
                spuMetaName: getSpuMetaName(key),
                spuMetaText: getSpuMetaText(key, spuMeta),
            },
        };
    }
    // 剩下的都是param
    return {
        key,
        type: (0, trade_1.paramKeyToParamType)(key),
        description: extraInfo[key],
        inputType: inputTypeConfig[key],
    };
}
const SPU_META_REG = new RegExp(`^${trade_1.BuyUITypeEnum.SpuMeta}://.+\\.(.+)$`);
function getSpuMetaName(key) {
    var _a;
    const matchArr = key === null || key === void 0 ? void 0 : key.match(SPU_META_REG);
    if ((matchArr === null || matchArr === void 0 ? void 0 : matchArr[1]) === ('ProductType')) {
        return '产品形态';
    }
    return (_a = matchArr === null || matchArr === void 0 ? void 0 : matchArr[1]) !== null && _a !== void 0 ? _a : key;
}
function getSpuMetaText(spuMetaKey, spuMeta) {
    const entries = Object.entries(spuMeta)
        .map(([key, value]) => {
        let text = value;
        if (key === 'ProductType') {
            text = ProductTypeText_1.ProductTypeTextMap[value];
        }
        return [key, text];
    })
        .map(([key, value]) => [`${trade_1.BuyUITypeEnum.SpuMeta}://${spuMeta.SpuCode}.${key}`, value]);
    const spuMetaWithParam = Object.fromEntries(entries);
    return spuMetaWithParam[spuMetaKey];
}
